import {
  Box,
  Button,
  Divider,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { FC, useMemo } from "react";
import { FormCliente } from "./FormCliente";
import { FormDistribuidorRevenda } from "./FormDistribuidorRevenda";
import { BottomBar } from "src/framework/components/commons/BottomBar";
import { PageTitle } from "./PageTitle";
import { Projeto } from "./types";
import { ValidateUtil } from "src/framework/commons/ValidateUtil";
import theme from "src/theme/light";
import { useObservable } from "src/framework/store/storeUtil";
import { isLoading$ } from "src/framework/store/ApiEvents";

const tipoProjetoString: { [index: string]: string } = {
  "dimensionado_offgrid": "dimensionado offgrid",
}

interface FormClientProperties {
    formState: any;
    onChangeValue: (formState: any) => void
    errorState: string[];
    onChangeError: (errorState: any) => void
    distribuidorRevendaUsuario: any
    readOnly?: boolean
    onClickNext: () => void
    onSaveAndClose: (formState: any) => void
}

const useStyles = makeStyles({
  customButton: {
    backgroundColor: '#CC8F00'
  },
})

const FormDados: FC<FormClientProperties> = ({ onSaveAndClose, onClickNext, readOnly, formState, onChangeValue, errorState, onChangeError, distribuidorRevendaUsuario }) => {
  const classes = useStyles()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const FooterBottom = isMobile ? Box : BottomBar;
  const isLoading = useObservable(isLoading$);
  
  const nextButtonIsDisabled = useMemo(() => {
    const requiredFields: (keyof Projeto)[] = [
      "cliente_proposta",
      "cidade",
      "estado",
      "tipo"
    ]

    if (formState.tipo !== "vertical") {
      requiredFields.push("latitude", "longitude")
    }

    for (const requiredField of requiredFields) {
      if (!formState?.[requiredField]) {
        return true;
      }
    }

    if (isLoading) return true;

    if (formState?.email_proposta && (!ValidateUtil.isValidEmail(formState?.email_proposta) || errorState?.includes('email_proposta'))) return true;

    if (formState?.cep && formState?.cep?.length < 9) return true;

  }, [formState, errorState, isLoading])

  const pageTitle = useMemo(()=>{
    let tipoString = formState?.tipo ? (tipoProjetoString[formState.tipo] || formState.tipo) : '';
    let segmentoString = formState?.segmento.includes("off") ? "Off Grid" : "On Grid";

    if(formState?.tipo && formState?.tipo === "dimensionado_offgrid") {
      segmentoString = "Off Grid";
      tipoString = tipoString.replace(" offgrid", "");
    }

    tipoString = tipoString.replace("vertical", "especial");

    if (!formState?.clonar_projeto && formState?.isEdit) return `Edição de projeto ${tipoString} ${segmentoString}`
    return `Novo projeto ${tipoString} ${segmentoString}`
  },[formState?.clonar_projeto, formState?.tipo, formState?.isEdit, formState?.segmento])

  return (
    <>
      <Box p={2}>
        <PageTitle title={pageTitle} subtitle='Preencha os dados do cliente' />
      </Box>

      <Divider className="X12" />

      <Box p={2}>
        <Box className="X12" py={2}>
          <Typography variant="h6" align="left"><strong>Dados do cliente:</strong></Typography>
        </Box>

        <FormDistribuidorRevenda
          errorState={errorState}
          formState={formState}
          distribuidorRevendaUsuario={distribuidorRevendaUsuario}
          onChangeError={onChangeError}
          onChangeValue={onChangeValue}
        />

        <FormCliente
          errorState={errorState}
          formState={formState}
          onChangeError={onChangeError}
          onChangeValue={onChangeValue}
        />
      </Box>

      <FooterBottom className="fotter-bottom">
        {!readOnly && (formState?.tipo !== 'kit') && (formState?.tipo !== 'vertical') && (!formState.isEdit) &&
          <Button
            disableElevation={true}
            color={"secondary"}
            variant={"contained"}
            onClick={() => onSaveAndClose(formState)}
            disabled={nextButtonIsDisabled}
            className={classes.customButton}
            fullWidth={isMobile}
            >
            Salvar e Fechar
          </Button>
        }
        {!readOnly && 
          <Tooltip title={nextButtonIsDisabled ? 'Para prosseguir, preencha os campos marcados como *obrigatório.' : ''}>
            <Button
              disableElevation={true}
              disabled={nextButtonIsDisabled}
              color={"primary"}
              variant={"contained"}
              onClick={onClickNext}
              fullWidth={isMobile}
              style={isMobile ? { marginTop: 10 } : {}}
              >
              Continuar meu projeto
            </Button>
          </Tooltip>
        }

        {!readOnly && nextButtonIsDisabled && isMobile && <Box className="label-inputs" color="">
          <small>Para prosseguir, preencha os campos marcados como <span className="label-emphasis">*</span>obrigatório.</small>
        </Box>}
      </FooterBottom>
    </>
  )
}

export { FormDados }